export class EmailTemplate {
  public emailTemplateID: number;
  public emailTemplateName: string;
  public emailTemplateContent: string;
  public emailTemplateSubject: string;
  public emailTemplateTriggerTo: string;
  public TemplateVariablesClassName: string;
  public emailTemplateType: string;
  public emailTemplateRoleIds: string;
  public emailTemplateisActive: boolean;
  public RoleIds: any[]=[];
  public TriggerTo: any[] = [];
  public TemplateVariablesClass: any[] = [];
  public TemplateVariables: any[] = [];
  public emailTemplateCommaSeperatedRoles: string;
}
export class enums {
  public id: number;
 
  public value: string;
}





// WEBPACK FOOTER //
// ./src/app/models/EmailTemplate/EmailTemplate-model.ts